import store from '@/state/store';
import projectSlice from '@/state/project.slice';
import { invitations as fetch } from '@/api/project';
import { handleError } from '@/actions/common';

export default async function (code: string): Promise<void> {
  try {
    const invitations = await fetch(code);
    store.dispatch(projectSlice.actions.setInvitations({
      code,
      invitations: invitations.map(({ id, participant, project }) => ({
        id,
        participant,
        access: project.access
      }))
    }));
  } catch (error) {
    handleError(error);
    throw error;
  }
};